export default [
    {
        path: '/tools/other-insurance',
        name: 'other_insurance',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Covers with other',
        },
        components: {
            default: () => import('@views/tools/OtherInsuranceIndex.vue'),
        },
    },
];
